import * as React from 'react';
import b_ from 'b_';
import Range, { Props as RangeProps } from './components/Range';

import './index.scss';

const b = b_.with('stock-filters-cap-range');

interface Props extends RangeProps {
  title: string;
}

const CapRange: React.SFC<Props> = ({ title, ...props }) => (
  <div className={b()}>
    <div className={b('title')}>{title}</div>
    <Range className={b('range')} {...props} />
  </div>
);

export default CapRange;
